// src/components/admin/nornsweave/modals/AddBlockModal.js
import React from 'react';
import TimePicker from '../../../TimePicker';
import { DAY_OPTIONS } from '../AdminNornsWeaveContext';

function AddBlockModal({ block, setBlock, onClose, onAdd }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
        <h3 className="text-2xl font-bold text-slate-800 mb-4">Add Schedule Block</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-slate-700 text-sm font-medium mb-1">Day of Week</label>
            <select
              className="w-full px-3 py-2 border border-slate-300 rounded-lg"
              value={block.day}
              onChange={(e) => setBlock({...block, day: e.target.value})}
            >
              {DAY_OPTIONS.map(day => (
                <option key={day.value} value={day.value}>{day.label}</option>
              ))}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <TimePicker
              label="Start Time"
              value={block.startTime}
              onChange={(val) => setBlock({...block, startTime: val})}
              required
            />
            <TimePicker
              label="End Time"
              value={block.endTime}
              onChange={(val) => setBlock({...block, endTime: val})}
              required
            />
          </div>
          <div>
            <label className="block text-slate-700 text-sm font-medium mb-1">Reason</label>
            <input
              type="text"
              placeholder="e.g., Planning Period, Lunch"
              className="w-full px-3 py-2 border border-slate-300 rounded-lg"
              value={block.reason}
              onChange={(e) => setBlock({...block, reason: e.target.value})}
            />
          </div>
          <div>
            <label className="block text-slate-700 text-sm font-medium mb-1">Affects Library</label>
            <select
              className="w-full px-3 py-2 border border-slate-300 rounded-lg"
              value={block.library}
              onChange={(e) => setBlock({...block, library: e.target.value})}
            >
              <option value="elementary">Elementary</option>
              <option value="middle">Middle School</option>
              <option value="both">Both</option>
            </select>
          </div>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-slate-200 text-slate-700 py-2 rounded-lg hover:bg-slate-300"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onAdd}
              className="flex-1 bg-gray-600 text-white py-2 rounded-lg hover:bg-gray-700"
            >
              Add Block
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddBlockModal;
